import {memo} from "react";
import {Button, Modal, Typography} from "antd";
import PropTypes from "prop-types";

const {Title, Text} = Typography;

const WinnerModal = ({open, winner, winnerIndex, maxWinners, isSaving, onConfirm}) => (
    <Modal
        open={open}
        title={<div className="text-center"><span className="text-xl">🎉 Азтан тодорлоо! 🎉</span></div>}
        closeIcon={false}
        footer={false}
        className="draw-modal"
        classNames={{mask: "draw-modal-mask"}}
        centered
        width={600}
        // The only way out is the confirm button: a stray ESC or backdrop click
        // must not fire the save path mid-draw.
        maskClosable={false}
        keyboard={false}
    >
        <div className="text-center py-6">
            <div className="text-6xl mb-4">🏆</div>
            <Title level={2} className="mb-2" style={{color: 'var(--draw-gold-bright)'}}>{winner?.name}</Title>
            <Text className="text-lg" style={{color: 'var(--draw-text)'}}>Регистрийн дугаар: {winner?.regnum}</Text>
            <br/>
            <Text className="text-md" style={{color: 'var(--draw-text-dim)'}}>Урамшууллын эрх: {winner?.lottery}</Text>

            <div className="mt-4 p-4 rounded-lg" style={{background: 'var(--draw-surface-raised)', border: '1px solid var(--draw-line)'}}>
                <Text type="secondary">Нийт ялагч: {winnerIndex} / {maxWinners}</Text>
            </div>

            <Button
                className="draw-gold-button my-5 w-[150px] h-[40px] text-lg rounded-lg font-semibold"
                onClick={onConfirm}
                loading={isSaving}
                disabled={isSaving}
            >
                Үргэлжлүүлэх
            </Button>
        </div>
    </Modal>
);

WinnerModal.propTypes = {
    open: PropTypes.bool.isRequired,
    winner: PropTypes.object,
    winnerIndex: PropTypes.number.isRequired,
    maxWinners: PropTypes.number.isRequired,
    isSaving: PropTypes.bool,
    onConfirm: PropTypes.func.isRequired,
};

export default memo(WinnerModal);
